import { render, staticRenderFns } from "./AdminTweetsTable.vue?vue&type=template&id=415ff7bb&scoped=true&"
import script from "./AdminTweetsTable.vue?vue&type=script&lang=js&"
export * from "./AdminTweetsTable.vue?vue&type=script&lang=js&"
import style0 from "./AdminTweetsTable.vue?vue&type=style&index=0&id=415ff7bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415ff7bb",
  null
  
)

export default component.exports